/* eslint-disable no-console */
import React, { useState } from 'react';

import { AccordionItem as InternalItem, ExternalAccordionItemProps } from './AccordionItem';

import s from './Accordion.module.scss';

interface AccordionProps {
  defaultOpenIndex?: number;
}

export const Accordion: React.FC<AccordionProps> = ({ children, defaultOpenIndex = 0 }) => {
  const [activeIndex, setActiveIndex] = useState<number>(defaultOpenIndex);

  const itemsWithInjectedProps = React.Children.map(children, (child, index) => {
    if (!React.isValidElement(child)) {
      return false;
    }

    const JSXProps: ExternalAccordionItemProps = child.props;

    const isActive = index === activeIndex;

    return (
      <InternalItem index={index} isActive={isActive} setActiveIndex={setActiveIndex} heading={JSXProps.heading}>
        {React.cloneElement(child)}
      </InternalItem>
    );
  });

  return <div className={s.accordion}>{itemsWithInjectedProps}</div>;
};

export const AccordionItem: React.FC<ExternalAccordionItemProps> = ({ children }) => <>{children}</>;

export default Accordion;
